import { render, staticRenderFns } from "./table-model.vue?vue&type=template&id=8168cdbe&scoped=true&"
import script from "./table-model.vue?vue&type=script&lang=js&"
export * from "./table-model.vue?vue&type=script&lang=js&"
import style0 from "./table-model.vue?vue&type=style&index=0&id=8168cdbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8168cdbe",
  null
  
)

export default component.exports